import SingleTrendCard from "./SingleTrendCard/SingleTrendCard";

import stl from "./TrendsList.module.css";

const TrendsList = ({ trendsList, currentPage }) => {

  return (
    <>
      <div className={stl.TL_container}>
        {trendsList.map((trend, idx) => {
          return (
            <SingleTrendCard
              key={idx}
              trend={trend}
              isEager={idx <= 2}
              currentPage={currentPage}
            />
          );
        })}
      </div>
    </>
  );
};

export default TrendsList;
